import { render, staticRenderFns } from "./industry-trends.vue?vue&type=template&id=4fbf2300&scoped=true"
import script from "./industry-trends.vue?vue&type=script&lang=js"
export * from "./industry-trends.vue?vue&type=script&lang=js"
import style0 from "./industry-trends.vue?vue&type=style&index=0&id=4fbf2300&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf2300",
  null
  
)

export default component.exports